import { ROOM_DISPLAY_PHASE } from '../room/useRoomPhase';

export const OWNER_CONSOLE_DISPLAY_CATEGORY = {
  UNRESOLVED: 'unresolved',
  WAITING: 'waiting',
  BETTING: 'betting',
  RESULT_INPUT: 'resultInput',
  RESULT_REVIEW: 'resultReview',
  ROUND_RESULT: 'roundResult',
  COMPLETED: 'completed',
};

export const OWNER_CONSOLE_DISPLAY_LABEL = {
  [OWNER_CONSOLE_DISPLAY_CATEGORY.UNRESOLVED]: 'フェーズ未判定',
  [OWNER_CONSOLE_DISPLAY_CATEGORY.WAITING]: '開始待ち / 参加受付中',
  [OWNER_CONSOLE_DISPLAY_CATEGORY.BETTING]: 'ベット受付中',
  [OWNER_CONSOLE_DISPLAY_CATEGORY.RESULT_INPUT]: 'ベット締切 / 結果入力待ち',
  [OWNER_CONSOLE_DISPLAY_CATEGORY.RESULT_REVIEW]: '結果確認中',
  [OWNER_CONSOLE_DISPLAY_CATEGORY.ROUND_RESULT]: '結果確定 / ラウンド結果',
  [OWNER_CONSOLE_DISPLAY_CATEGORY.COMPLETED]: 'ルーム終了',
};

const ROOM_DISPLAY_PHASE_TO_OWNER_CATEGORY = {
  [ROOM_DISPLAY_PHASE.INACTIVE]: OWNER_CONSOLE_DISPLAY_CATEGORY.WAITING,
  [ROOM_DISPLAY_PHASE.BETREADY]: OWNER_CONSOLE_DISPLAY_CATEGORY.WAITING,
  [ROOM_DISPLAY_PHASE.BET_TIME]: OWNER_CONSOLE_DISPLAY_CATEGORY.BETTING,
  [ROOM_DISPLAY_PHASE.BET_COMPLETION]: OWNER_CONSOLE_DISPLAY_CATEGORY.RESULT_INPUT,
  [ROOM_DISPLAY_PHASE.LOCKED]: OWNER_CONSOLE_DISPLAY_CATEGORY.RESULT_INPUT,
  [ROOM_DISPLAY_PHASE.RESULT_PENDING]: OWNER_CONSOLE_DISPLAY_CATEGORY.RESULT_REVIEW,
  [ROOM_DISPLAY_PHASE.CONFIRMED]: OWNER_CONSOLE_DISPLAY_CATEGORY.ROUND_RESULT,
  [ROOM_DISPLAY_PHASE.COMPLETED]: OWNER_CONSOLE_DISPLAY_CATEGORY.COMPLETED,
};

export const getOwnerConsoleDisplayMeta = ({ roomDisplayPhase, fallbackMessage = null }) => {
  const displayCategory = ROOM_DISPLAY_PHASE_TO_OWNER_CATEGORY[roomDisplayPhase]
    ?? OWNER_CONSOLE_DISPLAY_CATEGORY.UNRESOLVED;

  return {
    displayCategory,
    label: OWNER_CONSOLE_DISPLAY_LABEL[displayCategory],
    roomDisplayPhase,
    fallbackMessage: roomDisplayPhase ? fallbackMessage : (fallbackMessage ?? 'フェーズ未判定'),
  };
};
